import React, { Component } from 'react';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Events, Yandex } from 'src/api';
import { addListener, removeListener } from 'src/utils/resize-listener';
import EnrollBtn from './EnrollBtn';
import Geolocation from './Geolocation';
import './Event.scss';
import { Mixpanel } from '../Mixpanel';


class Event extends Component {
  constructor() {
    super();
    this.state = {
      ready: false,
      placeIsWrapped: false,
      tableIsWrapped: false,
      arrowIsUp: false,
      tableArrowIsUp: false,
      geolocation: [],
      mapIconLayout: '',
      geolocationError: false
    }

    this.buttonsRef = React.createRef();
    this.fixedButtonsRef = React.createRef();
    this.eventElementRef = React.createRef();
  }

  toggleWrap = key => {
    this.setState(state => ({
      [key]: !state[key]
    }));
  }

  componentDidMount() {
    Mixpanel.track('Page hackathon');
    window.addEventListener('scroll', this.handleOnScroll);
    addListener(document.body, this.handleOnScroll);

    this.getEventData();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleOnScroll);
    removeListener(document.body, this.handleOnScroll);
  }
  


  /**
   * Converting geoloc from server to array like for yandex maps (we retrieve from server in such format, "{55.7786867,37.6052364}")
   * @param {String} rawGeoloc - geolocation in string format
   * @return {Array}
   */
  convertEventGeolocation = (rawGeoloc) => {
    return rawGeoloc.substr(1, rawGeoloc.length - 2).split(',').map(coord => parseFloat(coord, 10))
  }

  async getLocationCoordinates(data) {
    if (data && data.place_coordinates) {
      return this.convertEventGeolocation(data.place_coordinates);
    }
    if (data && data.place && data.place.country && data.place.city) {
      return Yandex.getGeolocationByAdress(`${data.place.country}, ${data.place.city}`)
        .then((res) => {
          return res.data.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(' ').map(coord => parseFloat(coord, 10)).reverse()
        })
        .catch(() => [])
    }
    return [];
  }

  getEventData() {
    const id = this.props.match.params.id;
    Events.getEventById(id)
      .then(async response => {
        const coordinates = await this.getLocationCoordinates(response.data);
        this.setState({
          data: response.data,
          geolocation: coordinates,
        }, async () => {
          const timeTable = this.getTimetable(this.state.data);

          this.setState({
            tableArr: timeTable,
            ready: true,
          });
          this.takePartners(this.state.data);
          this.takeOrganizer(this.state.data);
        });
      })
      .catch(error => {
        console.log(error);
      });
  }

  handleOnScroll = () => {
    const buttonsRef = this.buttonsRef.current;
    const fixedButtonsRef = this.fixedButtonsRef.current;
    const eventElementRef = this.eventElementRef.current;
    if (!(buttonsRef && buttonsRef.getBoundingClientRect)) {
      return;
    }
    let btnsWrapperHeight = buttonsRef.getBoundingClientRect().top;
    if (btnsWrapperHeight <= -60) {
      fixedButtonsRef.style.display = 'flex';
    } else {
      fixedButtonsRef.style.display = 'none';
    }

    const eventElementScrollPosition = eventElementRef.offsetTop + eventElementRef.scrollHeight;
    // We don't let it go out of Events element(= below footer)
    if ((window.innerHeight + window.pageYOffset) > (eventElementScrollPosition + fixedButtonsRef.scrollHeight + 10)) {
      fixedButtonsRef.style.position = 'absolute';
      fixedButtonsRef.style.top = eventElementScrollPosition - fixedButtonsRef.scrollHeight - 10 + 'px';
    } else {
      fixedButtonsRef.style.position = 'fixed';
      fixedButtonsRef.style.top = '';
    }
  }

  takePartners = (data) => {
    Events.getEventPartners(data.id)
      .then(response => {
        this.setState({
          partnersData: response.data
        })
      });
  }

  takeOrganizer = (data) => {
    Events.getEventOrganizers(data.id)
      .then(response => {
        this.setState({
          organizerData: response.data
        })
      })
      .catch(error => {
        console.log(error);
      });
  }

  onGeolocationError = (geolocationError) => {
    this.setState({ geolocationError });
  }

  getTimetable = (data) => {
    let tableArr = '';
    try {
      tableArr = data.timetable;
    } catch(err) {
      console.error('Wasnt able to get "tableArr":', err);
    };
    if (!tableArr) {
      return []
    }
    return tableArr.split('|_|')
      .map(el => {
        return el.split('||');
      });
  }

  contentWrap = e => {
    e.target.classList.toggle('content-wrapped')
  }

  render() {
    if (!this.state.ready) {
      return <div className="event skeleton">
        <div className="loader">Loading...</div>
      </div>
    }
    return (
      <div className='event' ref={this.eventElementRef}>
        {
          this.state.data && 
          (
            <React.Fragment>
              <div className='block block_main'>
                <div className='header-wrapper'>
                  <div className='hackatone-short-info hackatone-dateto'>
                    <span role='img' aria-label="emoji">🔥 </span>{moment(this.state.data.start_date).fromNow()}
                  </div>
                  <div className='text-info text-info_date'>
                    {moment(this.state.data.start_date).locale('ru').format("D MMMM")} — {moment(this.state.data.end_date).locale('ru').format("D MMMM YYYY")} 
                  </div>
                </div>
                <h1>{this.state.data.name}</h1>
                <div className='text'>{this.state.data.full_description}</div>
                <div className='tags'>
                  {
                    this.state.data.tags.split(',').map((el, i) => {
                      return (
                        <div className='tag' key={i}>{el}</div>
                      )
                    })
                  }
                </div>
                <div className="btns_wrapper" ref={this.buttonsRef}>
                  <EnrollBtn hackathon={this.state.data} parent='Hackathons'></EnrollBtn>
                  <a className='btn btn_white' href={this.state.data.link} onClick={() => Mixpanel.track('Hackathon', {'Button':'Website'})} target='_blank' rel="noopener noreferrer">Сайт мероприятия</a>
                </div>

                <div className="btns_wrapper_fixed" ref={this.fixedButtonsRef}>
                  <EnrollBtn hackathon={this.state.data} parent='Hackathons'></EnrollBtn>
                  <a className='btn btn_white' href={this.state.data.link} onClick={() => Mixpanel.track('Hackathon', {'Button':'Website'})} target='_blank' rel="noopener noreferrer">Сайт мероприятия</a>
                </div>
              </div>
              <div className='separator' />
            </React.Fragment>
          )
        }

        <div className={this.state.placeIsWrapped ? 'block block_map block_wrapped' : 'block block_map'} >
          <div className="text_with_arrow" onClick={() => {this.toggleWrap('placeIsWrapped');this.toggleWrap('arrowIsUp')}}>
            {!this.state.geolocationError && <div className={this.state.arrowIsUp ? 'arrow-togle-btn up' : 'arrow-togle-btn'}/> }
            <h2>Место проведения</h2>
          </div>
          <div className='text-place'>
            {
              this.state.data && `${this.state.data.place.city}, ${this.state.data.place.country}`
            }
          </div>
          <div className='text-place'>
            {
              this.state.data && this.state.data.place_additional
            }
          </div>
          <Geolocation
            expanded={this.state.arrowIsUp}
            onError={this.onGeolocationError}
            hintMessage={this.state.data ? this.state.data.place_additional : ''}
            geolocation={this.state.geolocation}
          />
        </div>
        <div className='separator' />

        <div className='block block_organizer'>
          <h2>Организатор</h2>
          <div className='organizer-wrapper'>
            {
                this.state.organizerData &&
              <a href={this.state.organizerData.link} title={this.state.organizerData.name} target='_blank' rel="noopener noreferrer">
                <img src={this.state.organizerData.logo} alt={this.state.organizerData.name} key={this.state.organizerData.name}/>
                </a>
              }
          </div>
          
        </div>
        <div className='separator' />

        {
          this.state.partnersData && this.state.partnersData.length !== 0 && (
            <React.Fragment>
              <div className='block block_partners'>
                <h2>Партнеры</h2>
                <div className='partners-wrapper'>
                  {
                    this.state.partnersData && this.state.partnersData.map((el, index) => {
                      return (
                        <a href={el.link} title={el.name} target='_blank' key={index} rel="noopener noreferrer">
                          <img src={el.picture} alt={el.name} />
                        </a>
                      )
                    })
                  }
                </div>
              </div>
              <div className='separator' />
            </React.Fragment>
          )
        }

        {
          this.state.tableArr && this.state.tableArr.length !== 0 && (
            <React.Fragment>
              <div className={this.state.tableIsWrapped ? 'block block_table block_wrapped' : 'block block_table'}>
                <div className="table_text_with_arrow" onClick={() => { this.toggleWrap('tableIsWrapped'); this.toggleWrap('tableArrowIsUp') }}>
                  <div className={this.state.tableArrowIsUp ? 'arrow-togle-btn up' : 'arrow-togle-btn'} />
                  <h2>Расписание</h2>
                </div>

                {
                  this.state.tableArr && <div className='table'>
                    {
                      this.state.tableArr.map((el, index) => {
                        return (
                          <div className='table__row' key={index}>
                            <div className='table__cell table__cell_date'>{el[0]}</div>
                            <div className='table__cell table__cell_text' dangerouslySetInnerHTML={{ __html: el[1] }} />
                          </div>
                        )
                      })
                    }

                    <div className="table-overlay"></div>
                  </div>
                }
              </div>
              <div className='separator' />
            </React.Fragment>
          )
        }
      </div>
    );
  }
}

Event.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
}

export default withRouter(Event);



// WEBPACK FOOTER //
// ./src/components/Event/index.js